<template>
  <el-container class="app">
    <el-header height="50px"><ky-header :is-collapse="isCollapse" @toggleClick="toggleSideBar"></ky-header></el-header>
    <el-container class="app-body">
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <ky-menu :is-collapse="isCollapse"></ky-menu>
      </el-aside>
      <el-container class="app-content">
        <el-main>
          <router-view></router-view>
        </el-main>
        <el-footer height="30px"><ky-footer></ky-footer></el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>

<script type="text/babel">
  import KyHeader from 'components/KyHeader'
  import KyMenu from 'components/KyMenu'
  import KyFooter from 'components/KyFooter'
  import { mapActions } from 'vuex'

  export default {
    name: 'app',
    components: {
      KyHeader,
      KyMenu,
      KyFooter
    },
    data () {
      return {
        isCollapse: false,
        mainTop: 0
      }
    },
    methods: {
      ...mapActions([
        'loginStatus'
      ]),
      toggleSideBar () {
        this.isCollapse = !this.isCollapse
      }
    },
    created () {
      this.loginStatus()
    },

  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
.app
  height: 100%
  .el-header
    padding: 0
  .app-body
    .el-aside
      height: 100%
      background-color: #324157
    .app-content
      .el-main
        background-color: #ecf0f5
      .el-footer
        padding: 0
</style>



// WEBPACK FOOTER //
// src/views/Layout.vue